<template>
  <div>
    <div style="padding-bottom:100px">
      <Title text="线下支付" />
      <!-- 商品信息 -->
      <div class="product">
        <div style="text-align:center">
          <img src="../assets/images/order/order_img_zhifucg@2x.png" alt />
          <span>订单提交成功！请尽快支付您的订单</span>
        </div>
        <ul>
          <li>
            <span>订单号:</span>
            <span>{{order.sno}}</span>
          </li>
          <li>
            <span>应付金额：</span>
            <span style="color:#ff9900">￥{{order.totalAmount | moneyFilter}}</span>
          </li>
          <li>
            <span>下单时间：</span>
            <span>{{order.createdTime}}</span>
          </li>
        </ul>
      </div>
      <div class="hr"></div>
      <!-- 汇款信息 -->
      <div class="remittance">
        <span class="title">汇款信息</span>
        <span class="message">公司名称：深圳前海蚂蚁芯城科技有限公司</span>
        <span class="message">开户银行：招商银行股份有限公司深圳高新园支行</span>
        <span class="message">银行账户：7559 3180 7010 902</span>
        <div class="note">
          <p class="note-title">注意事项</p>
          <p>1.请在汇款时附言处注明订单号和用户名</p>
          <p>2.提交汇款凭证后，我司将尽快确认并反馈信息</p>
          <p>3.请确保汇款金额与订单金额一致，如有疑问可联系蚂蚁客服</p>
        </div>
      </div>
      <!-- 流水号及截图 -->
      <div class="serial">
        <div class="number">
          <span>流水号:</span>
          <input type="number" v-model="tradeNo" />
        </div>
        <div class="number screenshot">
          <span class="star">*</span>
          <span>汇款凭证或截图:</span>
        </div>
        <div style="display:flex">
          <!-- <img class="head-img" :src="imgAddress" v-if="imgAddress" /> -->
          <van-uploader v-model="fileList" multiple :after-read="afterRead" :max-count="1">
            <!-- <div class="imgbox">
            <img src="../assets/images/order/camera.png" />
            </div>-->
          </van-uploader>
        </div>
      </div>
    </div>
    <!-- 确认 -->
    <div class="footer">
      <button @click="addPay">立即提交</button>
    </div>
  </div>
</template>

<script>
import Title from "../components/Title";
import { OutlineOrder, Upload, payOffice } from "../request/api";
import { toMoney } from "../common/moneyFilter";
export default {
  data() {
    return {
      fileList: [],
      order: {},
      tradeNo: "",
      imgAddress: ""
    };
  },
  created() {
    this.getPayDetail();
  },
  filters: {
    moneyFilter(money) {
      return toMoney(money);
    }
  },
  components: {
    Title
  },
  methods: {
    //新增线下支付
    addPay() {
      let data = {
        tradeNo: this.tradeNo,
        imgAddress: this.imgAddress
      };
      if (data.imgAddress == "") {
        this.$toast("请上传汇款凭证");
        return;
      }
      payOffice(this.order.sno, data).then(res => {
        if (res.status == 200) {
          this.$toast("提交成功，等待审核");
          this.$router.push({
            name: "order-status",
            query: {
              sno: this.order.sno
            }
          });
        }
      });
    },
    //查询订单信息
    getPayDetail() {
      let sno = this.$route.query.sno;
      OutlineOrder(sno).then(res => {
        this.order = res.data;
        this.tradeNo =
          res.data.payOfflineTradeNo == null ? "" : res.data.payOfflineTradeNo;
        // this.fileList[0].url = res.data.payOfflineImgAddress == null ? [] : res.data.payOfflineImgAddress
      });
    },
    //图片
    afterRead(file) {
      //创建form对象
      let params = new FormData();
      //通过append向form对象添加数据//第一个参数字符串可以填任意命名，第二个根据对象属性来找到file
      params.append("file", file.file);
      let config = {
        headers: {
          //添加请求头
          "Content-Type": "multipart/form-data"
        }
      };
      Upload(params, config).then(res => {
        this.imgAddress = res.data;
        // this.$refs.goodsImg.src = res.data;
        // this.fileList[0].url = res.data
      });
    }
  }
};
</script>

<style lang="less" scoped>
.product {
  padding: 35px 30px;
  img {
    width: 30px;
    height: 30px;
    vertical-align: middle;
    margin-right: 10px;
  }
  ul {
    margin-top: 80px;
    li {
      line-height: 45px;
      font-size: 28px;
      span:nth-child(2) {
        float: right;
      }
    }
  }
}
.hr {
  width: 100%;
  height: 20px;
  background: #f5f5f5;
}
.remittance {
  padding: 30px;
  width: 100%;
  box-sizing: border-box;
  .title {
    font-size: 28px;
    color: #666;
  }
  .message {
    display: block;
    padding: 25px 0 15px;
    border-bottom: 2px solid #e6e6e6;
    font-size: 26px;
    color: #333;
  }
  .note {
    margin-top: 30px;
    font-size: 24px;
    color: #ccc;
    p {
      display: block;
      line-height: 45px;
    }
    .note-title {
      color: #cc1414;
    }
  }
}
.serial {
  padding: 0px 30px;
  width: 100%;
  box-sizing: border-box;
  font-size: 28px;
  color: #333;
  margin-bottom: 200px;
  .number {
    padding: 30px 0 10px 0;
    border-bottom: 2px solid #e6e6e6;
    .star {
      color: #cc1414;
    }
    input {
      display: inline-block;
      vertical-align: middle;
    }
  }
  .screenshot {
    border: none;
    margin-bottom: 10px;
  }
  .imgbox {
    width: 150px;
    height: 150px;
    border: 1px solid #ccc;
    position: relative;
    margin-left: 10px;
    img {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
    }
  }
  .head-img {
    width: 150px;
    height: 150px;
  }
}
.footer {
  width: 100%;
  height: 157px;
  padding: 30px;
  box-sizing: border-box;
  border-top: 2px solid #e6e6e6;
  position: fixed;
  bottom: 0;
  background: #fff;
  margin-top: 157px;
  button {
    width: 690px;
    height: 96px;
    background: #ff9900;
    line-height: 96px;
    font-size: 36px;
    color: #fff;
    border: none;
  }
}
</style>